<template>
  <div class="term-setting fb fb-cross-center fb-main-center ff-regular mark">
    <div class="term-container bg-FFFFFF p-0-16">
      <div class="p-20-0 text-center c-111F2C font-34">学年学期</div>
      <div>
        <div class="item-title font-30 c-111F2C-80 pt-4 lh-24">当前校区</div>
        <div
          class="item-value c-111F2C-40 font-34 h-44 lh-24 fb fb-cross-center text-ellipsis"
          >{{ computedCapmusName }}</div
        >
      </div>
      <div>
        <div class="item-title font-30 c-111F2C-80 pt-12 lh-24"
          >当前学年
          <span class="c-111F2C-28" v-if="pageIsUpgraded">(已升级)</span>
        </div>
        <div
          class="item-value c-111F2C-40 font-34 h-44 lh-24 fb fb-cross-center fb-main-between"
          >{{ schoolYearText }}
          <div
            class="text-center c-006AFE lh-24 font-30 p-0-12 pointer upgrade-button"
            v-if="!pageIsUpgraded && semesterSetting.canBeUpgraded"
            @click="showDialog = true"
            >升级学年</div
          >
        </div>
      </div>
      <div>
        <div class="item-title font-30 c-111F2C-80 pt-12 lh-24">当前学期</div>
        <div
          class="item-value c-111F2C-40 font-34 h-44 lh-24 fb fb-cross-center available"
          @click="showAction = true"
          >{{ `第${schoolTermOrder === 1 ? '一' : '二'}学期` }}
          <i class="iconfont font-32">&#xe613;</i>
        </div>
      </div>
      <div>
        <div class="item-title font-30 c-111F2C-80 pt-12 lh-24">起止日期</div>
        <div
          class="item-value item-date-range c-111F2C-40 font-34 h-44 lh-24 fb fb-cross-center fb-main-center"
          v-if="schoolTermOrder === 1"
        >
          <div
            @click="handlerSelectDate(1, pcFirstStart)"
            class="item-flex-1"
            :class="{
              'empty-value': !pcFirstStart
            }"
            >{{
              pcFirstStart ? pcFirstStart.replace(/-/g, '.') : '开始日期'
            }}</div
          >
          <div>~</div>
          <div
            @click="handlerSelectDate(2, pcFirstEnd)"
            class="item-flex-1 pl-14"
            :class="{
              'empty-value': !pcFirstEnd
            }"
            >{{ pcFirstEnd ? pcFirstEnd.replace(/-/g, '.') : '结束日期' }}</div
          >
        </div>
        <div
          class="item-value item-date-range c-111F2C-40 font-34 h-44 lh-24 fb fb-cross-center fb-main-center"
          v-else
        >
          <div
            @click="handlerSelectDate(3, pcSecondStart)"
            class="item-flex-1"
            :class="{
              'empty-value': !pcSecondStart
            }"
            >{{
              pcSecondStart ? pcSecondStart.replace(/-/g, '.') : '开始日期'
            }}</div
          >
          <div>~</div>
          <div
            @click="handlerSelectDate(4, pcSecondEnd)"
            class="item-flex-1 pl-14"
            :class="{
              'empty-value': !pcSecondEnd
            }"
            >{{
              pcSecondEnd ? pcSecondEnd.replace(/-/g, '.') : '结束日期'
            }}</div
          >
        </div>
      </div>
      <div class="config-buttons mb-20 mt-20 fb fb-main-center">
        <md-button
          @click="handlerSave"
          :disabled="saveLoading"
          class="width-full"
          >确定</md-button
        >
      </div>
    </div>

    <common-action-sheet
      :list="termList"
      :open="showAction"
      @cancel="showAction = false"
      @choose="handlerTermDialogChoose"
    >
    </common-action-sheet>
    <md-dialog
      @confirm="handlerUpgrade"
      type="confirm"
      v-model="showDialog"
      :confirmBtn="{
        text: '确认',
        color: '#F25643'
      }"
      :cancelBtn="{
        text: '取消',
        color: '#006AFE'
      }"
      title="升级学年"
      content="学年升级操作不可逆，升级后只可查询、操作升级后的学年。确认升级？"
    >
    </md-dialog>
  </div>
</template>

<script>
import mixin from '@/mixin'
import { mcDatePicker, mcToast } from '@/utils/mcSdkUtils'
import API from '@/api'
import commonActionSheet from './commonActionSheet'
import {
  handlerJudge,
  handlerMessage,
  timeFormat,
  dateToTime
} from '@/utils/comUtils'
import { mapGetters } from 'vuex'

export default {
  mixins: [mixin],
  name: 'commonTermSetting',
  components: { commonActionSheet },
  props: {},
  data() {
    return {
      saveLoading: false,
      termList: [
        {
          name: '第一学期',
          id: 1
        },
        {
          name: '第二学期',
          id: 2
        }
      ],
      showAction: false,
      showDialog: false,
      schoolYear: '',
      schoolTermOrder: 1,
      pcFirstStart: '',
      pcFirstEnd: '',
      pcSecondStart: '',
      pcSecondEnd: ''
    }
  },
  computed: {
    ...mapGetters(['semesterSetting', 'pageIsUpgraded']),
    computedCapmusName() {
      return this.$store.getters.currentCapmus.name
    },
    showTermDialog() {
      return this.semesterSetting.showTermDialog
    },
    schoolYearText() {
      if (this.semesterSetting && this.semesterSetting.schoolYear) {
        return `${this.semesterSetting.schoolYear} - ${
          this.semesterSetting.schoolYear + 1
        }学年`
      }
      return ``
    }
  },
  watch: {
    showTermDialog(val) {
      // 每次出现初始化
      if (val) {
        this.init()
      }
    },
    computedSchoolYear(val) {
      this.schoolYear = val
    }
  },
  beforeCreate() {},
  created() {
    setTimeout(() => {
      this.init()
    }, 1)
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {
      this.pcFirstStart = this.handlerGetCorrectTime(1)
      this.pcFirstEnd = this.handlerGetCorrectTime(2)
      this.pcSecondStart = this.handlerGetCorrectTime(3)
      this.pcSecondEnd = this.handlerGetCorrectTime(4)
      this.schoolTermOrder = this.semesterSetting.termOrder
    },
    handlerGetCorrectTime(type) {
      const { firstStart, firstEnd, secondStart, secondEnd } =
        this.$store.getters.semesterSetting
      let value = ''
      switch (type) {
        case 1:
          value = dateToTime(firstStart, '-') || ''
          break
        case 2:
          value = dateToTime(firstEnd, '-') || ''
          break
        case 3:
          value = dateToTime(secondStart, '-') || ''
          break
        case 4:
          value = dateToTime(secondEnd, '-') || ''
          break
        default:
          break
      }
      return value
    },
    handlerSave(sequence) {
      let order = sequence === 'second' ? 2 : 1
      let message = ''
      let saveOther = false // 是否保存其他数据
      const temp = this.handlerGetList()
      if (sequence !== 'second') {
        let returnObj = handlerMessage(temp, sequence === 'second' ? 2 : 1)
        message = returnObj.message
        order = returnObj.order
        saveOther = returnObj.saveOther
        // 不符合条件直接报错
        if (message) {
          return mcToast({ msg: message })
        }
        let isError = handlerJudge(this.semesterSetting, temp)
        if (isError) {
          return mcToast({ msg: isError })
        }
      }
      const schoolTermStartDimDay =
        order === 1
          ? temp[0].schoolTermStartDimDay
          : temp[1].schoolTermStartDimDay

      const schoolTermEndDimDay =
        order === 1 ? temp[0].schoolTermEndDimDay : temp[1].schoolTermEndDimDay

      const saveOrUpdateTermReq = {
        schoolYear: this.semesterSetting.schoolYear,
        termOrder: order,
        termStartDimDay: +schoolTermStartDimDay.replace(/-/g, ''),
        termEndDimDay: +schoolTermEndDimDay.replace(/-/g, ''),
        orgId: this.orgId,
        campusId: this.campusId,
        operUserDingId: this.dingUserId,
        operUserName: this.dingUserName,
        operUserRoleTypes: this.currentRole
      }
      this.fetchSaveSchoolTermSetting(sequence, saveOther, saveOrUpdateTermReq)
    },
    fetchSaveSchoolTermSetting(sequence, saveOther, saveOrUpdateTermReq) {
      this.saveLoading = true
      API.saveSchoolTermSetting(saveOrUpdateTermReq)
        .then(res => {
          if (res && res.result && +res.result !== 0) {
            mcToast({ msg: res.message })
            this.saveLoading = false
            return false
          }
          if (saveOther && sequence !== 'second') {
            this.handlerSave('second')
            return
          }
          mcToast({ msg: '保存成功' })
          this.$store
            .dispatch('handlerCheckSemester')
            .then(() => {
              this.init()
            })
            .catch(err => {
              console.log('unhandledrejection', err)
            })
          this.saveLoading = false
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
        .finally(() => {
          this.saveLoading = false
        })
    },
    handlerUpgrade() {
      this.showDialog = false
      this.$store
        .dispatch('handlerUpdateSemesterYear')
        .then(res => {
          mcToast({ msg: res.message || '升级成功' })
          this.$store
            .dispatch('handlerCheckSemester')
            .then(() => {
              this.init()
            })
            .catch(err => {
              console.log('unhandledrejection', err)
            })
        })
        .catch(err => {
          mcToast({ msg: err.message })
        })
    },
    handlerSelectDate(type, value) {
      const temp = this.handlerGetList()
      mcDatePicker({
        date: value || timeFormat(new Date()),
        format: 'YYYY-MM-DD'
      })
        .then(({ date, picker } = {}) => {
          switch (type) {
            case 1:
              temp[0].schoolTermStartDimDay = date
              const firstMessage = handlerJudge(
                this.semesterSetting,
                temp,
                '1-schoolTermStartDimDay'
              )
              if (firstMessage) {
                picker.reset()
                mcToast({ msg: firstMessage })
              } else {
                this.pcFirstStart = date
              }
              break
            case 2:
              temp[0].schoolTermEndDimDay = date
              const secondMessage = handlerJudge(
                this.semesterSetting,
                temp,
                '1-schoolTermEndDimDay'
              )
              if (secondMessage) {
                picker.reset()
                mcToast({ msg: secondMessage })
              } else {
                this.pcFirstEnd = date
              }
              break
            case 3:
              temp[1].schoolTermStartDimDay = date

              const threeMessage = handlerJudge(
                this.semesterSetting,
                temp,
                '2-schoolTermStartDimDay'
              )
              if (threeMessage) {
                picker.reset()
                mcToast({ msg: threeMessage })
              } else {
                this.pcSecondStart = date
              }
              break
            case 4:
              temp[1].schoolTermEndDimDay = date
              const fourMessage = handlerJudge(
                this.semesterSetting,
                temp,
                '2-schoolTermEndDimDay'
              )
              if (fourMessage) {
                picker.reset()
                mcToast({ msg: fourMessage })
              } else {
                this.pcSecondEnd = date
              }
              break
            default:
              break
          }
        })
        .catch(err => console.log(err))
    },
    handlerGetList() {
      return [
        {
          schoolTermStartDimDay:
            (this.pcFirstStart &&
              timeFormat(new Date(this.pcFirstStart), 'YYYY-MM-DD')) ||
            '',
          schoolTermEndDimDay:
            (this.pcFirstEnd &&
              timeFormat(new Date(this.pcFirstEnd), 'YYYY-MM-DD')) ||
            ''
        },
        {
          schoolTermStartDimDay:
            (this.pcSecondStart &&
              timeFormat(new Date(this.pcSecondStart), 'YYYY-MM-DD')) ||
            '',
          schoolTermEndDimDay:
            (this.pcSecondEnd &&
              timeFormat(new Date(this.pcSecondEnd), 'YYYY-MM-DD')) ||
            ''
        }
      ]
    },
    handlerTermDialogChoose(item) {
      this.schoolTermOrder = item.id
      this.showAction = false
    }
  }
}
</script>

<style lang="scss" scoped>
.upgrade-button {
  border-left: solid 1px rgba(23, 26, 29, 0.24);
}
.mark {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.4);
}
.term-setting {
  padding: 0 16px;
  .term-container {
    border-radius: 12px;
    width: 100%;
    .item-value {
      background: rgba(17, 31, 44, 0.08);
      border-radius: 6px;
      padding: 0 12px;
      &.item-date-range {
        background: #ffffff;
        border: 1px solid rgba(17, 31, 44, 0.12);
        color: #111f2c;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        .empty-value {
          color: rgba(17, 31, 44, 0.28);
          font-family: PingFangSC-Regular;
          font-weight: normal;
        }
      }
      &.available {
        border: 1px solid rgba(17, 31, 44, 0.12);
        background: #fff;
        color: #111f2c;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        position: relative;
        i {
          position: absolute;
          top: 9px;
          right: 14px;
          color: rgba(25, 31, 37, 0.4);
        }
      }
    }
  }
}
</style>
